import Grid from "components/Grid";
import { Content } from "components/Content/styles";

function Projects() {
  return (
    <Content>
      <Grid />
    </Content>
  );
}

export default Projects;
